module.exports = __webpack_public_path__ + "static/media/png.a6a7ac50.png";